import React from "react";

/** Lien Scout building mark — icon-only crop of the official brand PNG. */
export function HexLogo({ size = 44, className = "" }) {
  return (
    <img
      src="/brand/logo-icon.png"
      alt="Lien Scout"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: "contain" }}
    />
  );
}

/** Full lockup (icon + LIEN SCOUT wordmark + tagline) for landing hero + auth pages. */
export function BrandLockup({ width = 220, className = "" }) {
  return (
    <img
      src="/brand/logo-full.png"
      alt="Lien Scout — AI Powered Property Intelligence"
      width={width}
      className={className}
      style={{ objectFit: "contain" }}
    />
  );
}

/** Small hexagonal status badge. */
export function HexBadge({ children, tone = "default", className = "" }) {
  const tones = {
    default: "bg-zinc-100 text-zinc-800 border-zinc-300",
    success: "bg-emerald-100 text-emerald-800 border-emerald-300",
    error: "bg-red-100 text-red-800 border-red-300",
    warning: "bg-yellow-100 text-yellow-900 border-yellow-400",
    running: "bg-yellow-200 text-yellow-900 border-yellow-500",
  };
  return (
    <span
      className={`clip-hex px-3 py-1 border-2 text-[10px] font-mono-data font-semibold uppercase tracking-widest inline-flex items-center ${tones[tone] || tones.default} ${className}`}
    >
      {children}
    </span>
  );
}
